import BaseApi from './baseApi';
import ICompanyAdresses from '../models/ICompanyAdresses';
import IAuthentication from '../models/IAuthentication';
export default class CompanyAdressesApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Companies");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetCompanyAdresses(companyId: string) : Promise<ICompanyAdresses[]> {
        const json = this.getJsonRead(companyId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var companyAdresses: ICompanyAdresses[] = [];
            companyAdresses = response.data as ICompanyAdresses[];
            return companyAdresses;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveCompanyAdres(companyAdress: ICompanyAdresses) : Promise<string> {
        const json = this.getJsonSave(companyAdress);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateCompanyAdres(companyAdress: ICompanyAdresses) : Promise<boolean> {
        const json = this.getJsonUpdate(companyAdress);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteCompanyAdres(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "CompaniesAdresses",
            "conditions": [{
                "Item1": "CompaniesAdresses",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(companyAdress: ICompanyAdresses) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "street",
                "Item2": companyAdress.street
            }, {
                "Item1": "Number",
                "Item2": companyAdress.number
            }, {
                "Item1": "City",
                "Item2": companyAdress.city
            }, {
                "Item1": "ZipCode",
                "Item2": companyAdress.zipCode
            }, {
                "Item1": "IdListCountry",
                "Item2": companyAdress.idListCountry
            }, {
                "Item1": "IdCompany",
                "Item2": companyAdress.idCompany
            }, {
                "Item1": "IdListAdressType",
                "Item2": companyAdress.idListAdressType
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "CompaniesAdresses"
        };
        return json;
    }

    private getJsonUpdate(companyAdress: ICompanyAdresses) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "street",
                "Item2": companyAdress.street
            }, {
                "Item1": "Number",
                "Item2": companyAdress.number
            }, {
                "Item1": "City",
                "Item2": companyAdress.city
            }, {
                "Item1": "ZipCode",
                "Item2": companyAdress.zipCode
            }, {
                "Item1": "IdListCountry",
                "Item2": companyAdress.idListCountry
            }, {
                "Item1": "IdCompany",
                "Item2": companyAdress.idCompany
            }, {
                "Item1": "IdListAdressType",
                "Item2": companyAdress.idListAdressType
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "CompaniesAdresses",
            "keyvalue": companyAdress.id
        };
        return json;
    }

    private getJsonRead(companyId: string) : any {
        const json = {
            "fields": [{
                "Item1": "CompaniesAdresses",
                "Item2": "id"
            }, {
                "Item1": "CompaniesAdresses",
                "Item2": "street"
            }, {
                "Item1": "CompaniesAdresses",
                "Item2": "number"
            }, {
                "Item1": "CompaniesAdresses",
                "Item2": "city"
            }, {
                "Item1": "CompaniesAdresses",
                "Item2": "zipCode"
            }, {
                "Item1": "CompaniesAdresses",
                "Item2": "idListCountry"
            }, {
                "Item1": "ListCountries",
                "Item2": "countryName"
            }, {
                "Item1": "ListCountries",
                "Item2": "code"
            }, {
                "Item1": "CompaniesAdresses",
                "Item2": "idCompany"
            }, {
                "Item1": "CompaniesAdresses",
                "Item2": "idListAdressType"
            }, {
                "Item1": "ListAdressTypes",
                "Item2": "typeName"
            }],
            "tables": [{
                "Item1": "CompaniesAdresses"
            }, {
                "Item1": "ListCountries"
            }, {
                "Item1": "ListAdressTypes"
            }],
            "joins": [{
                "Item1": "CompaniesAdresses",
                "Item2": "IdListCountry",
                "Item3": "ListCountries",
                "Item4": "Id"
            }, {
                "Item1": "CompaniesAdresses",
                "Item2": "IdListAdressType",
                "Item3": "ListAdressTypes",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "CompaniesAdresses",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "CompaniesAdresses",
                "Item2": "IdCompany",
                "Item3": "=",
                "Item4": companyId
            }]
        };
        return json;
    }
}
